import {Component, computed, Input, Signal} from '@angular/core';
import {Project} from "../../api/model/project";
import {AlertDetailed, AlertGrouped, AlertType} from "../../api/model/alert";
import _ from 'lodash';
import {groupAlerts} from "../../api/alert.service";
import {BelongsTo} from "../../api/model/common";

@Component({
  selector: 'app-project-alert-icon',
  templateUrl: './project-alert-icon.component.html',
  styleUrls: ['./project-alert-icon.component.sass']
})
export class ProjectAlertIconComponent {
  @Input() project!: Project;
  @Input() alerts!: Signal<AlertDetailed[]>;
  @Input() linked: boolean = false;
  projectAlerts: Signal<AlertDetailed[]> = computed(() => {
    return this.alerts().filter(a => a.belongsTo == (BelongsTo.PROJECT || a.belongsTo == BelongsTo.EQUIPMENT) && a.project.id == this.project.id || a.equipment?.assignedProjectIds?.includes(this.project.id));
  });
  groupedAlerts: Signal<AlertGrouped[]> = computed(() => {
    const projectAlerts = this.projectAlerts();
    const groupedAlerts = groupAlerts(projectAlerts, false);
    console.log("ProjectAlertIconComponent computing", projectAlerts, groupedAlerts);
    return groupedAlerts;
  })
  alertTypes: Signal<AlertType[]> = computed(() => {
    return _.uniq(this.projectAlerts().map(a => a.type));
  })
}
